export const CommonPracticeCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Pratiche',
    path: '/pratiche',
  },
];

export const PracticeResearchCrumbs = [
  ...CommonPracticeCrumbs,
  {
    name: 'Ricerca pratiche',
    path: '/pratiche/ricerca',
  },
];

export const PracticeAssignOperatorCrumbs = [
  ...PracticeResearchCrumbs,
  {
    name: 'Assegnazione pratica operatore',
    path: '/pratiche/ricerca/assegnazione-operatore',
  },
];

export const PracticesAssignOperatorCrumbs = [
  ...CommonPracticeCrumbs,
  {
    name: 'Assegnazione pratiche operatore',
    path: '/pratiche/assegnazione-operatore-pratiche',
  },
];

export const PracticeDetailCrumbs = [
  ...PracticeResearchCrumbs,
  {
    name: 'Dettaglio pratica',
    path: '/pratiche/ricerca/dettaglio/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica',
  },
];

export const PracticeManagementCrumbs = [
  ...PracticeResearchCrumbs,
  {
    name: 'Gestione pratica',
    path: '/pratiche/ricerca/gestione-pratica/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica',
  },
];

export const PracticeManagementUnavailabilityCrumbs = [
  ...PracticeResearchCrumbs,
  {
    name: 'Gestione pratica',
    path: '/pratiche/ricerca/gestione-pratica/irreperibilita/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:idDbLocaleRichiedente/:idAnprIntestatario/:tipoPratica',
  },
];

export const PracticeEditCrumbs = [
  ...PracticeResearchCrumbs,
  {
    name: 'Modifica pratica',
    path: '/pratiche/ricerca/dettaglio',
  },
];

export const PracticeNewCrumbs = [
  ...PracticeResearchCrumbs,
  {
    name: 'Nuova pratica',
    path: '/pratiche/ricerca/dettaglio',
  },
];

export const PraticeUnAvailabilityCrumbs = [
  ...PracticeResearchCrumbs,
  {
    name: 'Modifica pratica di irreperibilità',
  },
];
